import React from 'react';
import { FaCheckCircle, FaExclamationTriangle, FaInfoCircle, FaTimes } from 'react-icons/fa';
import './CustomAlert.css';

const CustomAlert = ({ 
  isOpen, 
  onClose, 
  title, 
  message, 
  type = 'info', 
  showConfirm = false, 
  onConfirm, 
  confirmText = 'OK',
  cancelText = 'Cancel'
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <FaCheckCircle className="alert-icon success" />;
      case 'warning':
        return <FaExclamationTriangle className="alert-icon warning" />;
      case 'error':
        return <FaExclamationTriangle className="alert-icon error" />;
      default:
        return <FaInfoCircle className="alert-icon info" />;
    }
  };

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    onClose();
  };

  return (
    <div className="custom-alert-overlay">
      <div className="custom-alert-container">
        <div className="custom-alert-header">
          {getIcon()}
          <button className="alert-close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        
        <div className="custom-alert-content">
          {title && <h3 className="alert-title">{title}</h3>}
          <p className="alert-message">{message}</p>
        </div>
        
        <div className="custom-alert-actions">
          {showConfirm ? (
            <>
              <button className="alert-btn cancel-btn" onClick={onClose}>
                {cancelText}
              </button>
              <button className="alert-btn confirm-btn" onClick={handleConfirm}>
                {confirmText}
              </button>
            </>
          ) : (
            <button className="alert-btn confirm-btn" onClick={onClose}>
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomAlert;